import { ChangeEvent } from 'react';
import cn from 'classnames';
import { ImportContributionFields } from 'services/requests';
import { useModalState } from 'hooks/modals';
import { useImportContributionsForm } from 'hooks/forms';
import { useImportContributions } from 'hooks/api/contributions';
import { ImportIcon_24 } from 'assets/icons';
import buttonStyles from 'components/Button/Button.module.css';
import CSVField from 'components/CSVField';
import ImportCsvModal from '../ImportCsvModal';

import styles from './ImportCsv.module.css';
import messages from './ImportCsv.messages';

const ImportCsv = (): JSX.Element => {
  const form = useImportContributionsForm();

  const { isModalVisible, openModal, closeModal } = useModalState();
  const { mutateAsync: importContributions, isLoading } = useImportContributions();

  const onInput = (event: ChangeEvent<HTMLInputElement>) => {
    if (event?.target?.files?.[0]) {
      openModal();
    }
  };

  const onSubmit = async () => {
    const { file } = form.getValues();
    if (file) {
      await importContributions(
        { file: file[0] },
        { onError: onClose, onSuccess: onClose },
      );
    }
  };

  const onClose = () => {
    form.reset();
    closeModal();
  };

  return (
    <>
      <CSVField
        form={form}
        id={ImportContributionFields.file}
        onSubmit={onSubmit}
        onClose={onClose}
        onInput={onInput}
      >
        <div className={cn(buttonStyles.button)}>
          <ImportIcon_24 className={styles.plusIcon} />
          {messages.importCSV}
        </div>
      </CSVField>

      <ImportCsvModal
        isOpen={isModalVisible}
        onRequestClose={onClose}
        onSubmit={form.handleSubmit(onSubmit, onClose)}
        isLoading={isLoading}
      />
    </>
  );
};

export default ImportCsv;
